module.exports = __webpack_public_path__ + "static/img/img19.56a0989.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ychy/img19.png
// module id = RpFB
// module chunks = 1